import {
  Box,
  Container,
  Typography,
  useTheme,
  alpha
} from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../core/hooks/useStore";
import { RootState } from "../../../../core/store/store";
import HeadlinePigResultsTable from "./results-table";

const HeadlinePigResults = (props: any) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const { apiUrl } = useSelector((state: RootState) => state.home);
  const integrationData = useSelector((state: RootState) => state.integrations);

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      {/* Header Section */}
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography 
          variant="h4" 
          gutterBottom 
          sx={{ 
            fontWeight: 700, 
            mb: 1,
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}
        >
          Your Results Are In!
        </Typography>
        <Typography variant="body1" color="text.secondary">
          We've found several high-impact headlines for your content
        </Typography>
      </Box>

      {/* Results Table */}
      <HeadlinePigResultsTable />
    </Container>
  );
};

export default HeadlinePigResults;